var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.85 14.77a3 3 0 0 0 1.14.23H12a3 3 0 1 0-1.15-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.94 8.29c-.15-3.1-2.14-5.07-5.23-5.23-1.48-.08-5.94-.08-7.42 0-3.1.15-5.07 2.13-5.23 5.22-.08 1.5-.08 5.95 0 7.43.15 3.1 2.14 5.07 5.23 5.23 1.48.08 5.94.08 7.42 0 3.1-.15 5.07-2.14 5.23-5.23.08-1.48.08-5.94 0-7.42Zm-4.02-.4a1.5 1.5 0 1 0 1.16-2.77 1.5 1.5 0 0 0-1.16 2.76Zm-6.84 8.73a5 5 0 0 0 1.9.38H12a5 5 0 1 0-1.92-.38Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.116fe5fc0f0451251cd8a5e74c2db109.svg";
export { ForwardRef as ReactComponent };